export const SET_NAVIGATION_DRAWER_OPEN_REQUESTED =
  'SET_NAVIGATION_DRAWER_OPEN_REQUESTED';
export const SET_NAVIGATION_DRAWER_OPEN_COMPLETED =
  'SET_NAVIGATION_DRAWER_OPEN_COMPLETED';
